import React from 'react';

function PicModal({ details }) {

    return (
        <div className="modal fade" id="picModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                {details.name ? <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="staticBackdropLabel">{details.name}</h5>
                        <i className='bi bi-x bx-sm' style={{ cursor: "pointer" }} data-bs-dismiss="modal" aria-label="Close"></i>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid text-center">
                            {details.pic && <img src={details.pic} className='img-fluid' alt="..." />}
                        </div>
                    </div>
                </div> : null}
            </div>
        </div>

    );
}

export default React.memo(PicModal);